import React from "react";
import {Box, Column, Columns, Field, Input, Title} from "@allxsmith/bestax-bulma";


export default function MovementDetails({onChange, contact}){



    return (
        <Box>
            <details>
                <summary><Title>Movement Details</Title></summary>
            <Columns isMultiline>
                <Column>
                    <Field>
                        <label className="label">Movement Markup %</label>
                        <Input
                            type={"number"}
                            value={contact.movement_markup}
                            onChange={onChange}
                            name={"movement_markup"}
                        />
                    </Field>
                </Column>
                <Column></Column>
                <Column></Column>
                <Column></Column>
            </Columns>
            </details>
        </Box>
    );
}